import { ReactElement, ReactNode } from 'react'

import { ImportedInvoiceDocumentPreview } from '../../../ImportedInvoiceDocumentPreview'
import * as Styled from './styles'

interface ImportedInvoiceDrawerColumnsProps {
  children: ReactNode
  fileId: string
}

export const ImportedInvoiceDrawerColumns = ({ children, fileId }: ImportedInvoiceDrawerColumnsProps): ReactElement => (
  <Styled.ImportedInvoiceDrawerColumnsWrapper>
    <ImportedInvoiceDocumentPreview fileId={fileId} />
    {children}
  </Styled.ImportedInvoiceDrawerColumnsWrapper>
)
